/**
 * buysupply-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ActivityRequest', 'model/ActivityResponse', 'model/ApplicationRequest', 'model/ApplicationResponse', 'model/BusinessBean', 'model/BusinessIndustryRequest', 'model/BusinessIndustryResponse', 'model/BusinessRequest', 'model/BusinessResponse', 'model/ComponentRequest', 'model/ComponentResponse', 'model/ConfigurationRequest', 'model/ConfigurationResponse', 'model/ContactRequest', 'model/ContactResponse', 'model/FormItemRequest', 'model/FormItemResponse', 'model/FormRequest', 'model/FormResponse', 'model/GenericBean', 'model/IActivityBean', 'model/IApplicationBean', 'model/IBusinessIndustryResponse', 'model/IComponentBean', 'model/IContactBean', 'model/IFormBean', 'model/IFormItemBean', 'model/IMatrixBean', 'model/IMatrixItemBean', 'model/IProductBean', 'model/IProfileBean', 'model/IProfileItemBean', 'model/IProfileRequestBean', 'model/IProfileResponse', 'model/LoginRequest', 'model/LoginResponse', 'model/MatrixItemBean', 'model/MatrixItemRequest', 'model/MatrixItemResponse', 'model/MatrixRequest', 'model/MatrixResponse', 'model/PdfBean', 'model/PdfRequest', 'model/PdfResponse', 'model/ProductRequest', 'model/ProductResponse', 'model/ProfileItemBean', 'model/ProfileItemRequest', 'model/ProfileItemResponse', 'model/ProfileRequest', 'model/ProfileRequestRequest', 'model/ProfileRequestResponse', 'model/ProfileResponse', 'model/RegisterRequest', 'model/RegisterResponse', 'model/UserBean', 'model/UserRequest', 'model/UserResponse', 'api/DefaultApi'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('./ApiClient'), require('./model/ActivityRequest'), require('./model/ActivityResponse'), require('./model/ApplicationRequest'), require('./model/ApplicationResponse'), require('./model/BusinessBean'), require('./model/BusinessIndustryRequest'), require('./model/BusinessIndustryResponse'), require('./model/BusinessRequest'), require('./model/BusinessResponse'), require('./model/ComponentRequest'), require('./model/ComponentResponse'), require('./model/ConfigurationRequest'), require('./model/ConfigurationResponse'), require('./model/ContactRequest'), require('./model/ContactResponse'), require('./model/FormItemRequest'), require('./model/FormItemResponse'), require('./model/FormRequest'), require('./model/FormResponse'), require('./model/GenericBean'), require('./model/IActivityBean'), require('./model/IApplicationBean'), require('./model/IBusinessIndustryResponse'), require('./model/IComponentBean'), require('./model/IContactBean'), require('./model/IFormBean'), require('./model/IFormItemBean'), require('./model/IMatrixBean'), require('./model/IMatrixItemBean'), require('./model/IProductBean'), require('./model/IProfileBean'), require('./model/IProfileItemBean'), require('./model/IProfileRequestBean'), require('./model/IProfileResponse'), require('./model/LoginRequest'), require('./model/LoginResponse'), require('./model/MatrixItemBean'), require('./model/MatrixItemRequest'), require('./model/MatrixItemResponse'), require('./model/MatrixRequest'), require('./model/MatrixResponse'), require('./model/PdfBean'), require('./model/PdfRequest'), require('./model/PdfResponse'), require('./model/ProductRequest'), require('./model/ProductResponse'), require('./model/ProfileItemBean'), require('./model/ProfileItemRequest'), require('./model/ProfileItemResponse'), require('./model/ProfileRequest'), require('./model/ProfileRequestRequest'), require('./model/ProfileRequestResponse'), require('./model/ProfileResponse'), require('./model/RegisterRequest'), require('./model/RegisterResponse'), require('./model/UserBean'), require('./model/UserRequest'), require('./model/UserResponse'), require('./api/DefaultApi'));
  }
}(function(ApiClient, ActivityRequest, ActivityResponse, ApplicationRequest, ApplicationResponse, BusinessBean, BusinessIndustryRequest, BusinessIndustryResponse, BusinessRequest, BusinessResponse, ComponentRequest, ComponentResponse, ConfigurationRequest, ConfigurationResponse, ContactRequest, ContactResponse, FormItemRequest, FormItemResponse, FormRequest, FormResponse, GenericBean, IActivityBean, IApplicationBean, IBusinessIndustryResponse, IComponentBean, IContactBean, IFormBean, IFormItemBean, IMatrixBean, IMatrixItemBean, IProductBean, IProfileBean, IProfileItemBean, IProfileRequestBean, IProfileResponse, LoginRequest, LoginResponse, MatrixItemBean, MatrixItemRequest, MatrixItemResponse, MatrixRequest, MatrixResponse, PdfBean, PdfRequest, PdfResponse, ProductRequest, ProductResponse, ProfileItemBean, ProfileItemRequest, ProfileItemResponse, ProfileRequest, ProfileRequestRequest, ProfileRequestResponse, ProfileResponse, RegisterRequest, RegisterResponse, UserBean, UserRequest, UserResponse, DefaultApi) {
  'use strict';

  /**
   * ERROR_UNKNOWN.<br>
   * The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
   * <p>
   * An AMD (recommended!) or CommonJS application will generally do something equivalent to the following:
   * <pre>
   * var BuysupplyProductionappspotcom = require('index'); // See note below*.
   * var xxxSvc = new BuysupplyProductionappspotcom.XxxApi(); // Allocate the API class we're going to use.
   * var yyyModel = new BuysupplyProductionappspotcom.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * <em>*NOTE: For a top-level AMD script, use require(['index'], function(){...})
   * and put the application logic within the callback function.</em>
   * </p>
   * <p>
   * A non-AMD browser application (discouraged) might do something like this:
   * <pre>
   * var xxxSvc = new BuysupplyProductionappspotcom.XxxApi(); // Allocate the API class we're going to use.
   * var yyy = new BuysupplyProductionappspotcom.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * </p>
   * @module index
   * @version 1.0.0
   */
  var exports = {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient: ApiClient,
    /**
     * The ActivityRequest model constructor.
     * @property {module:model/ActivityRequest}
     */
    ActivityRequest: ActivityRequest,
    /**
     * The ActivityResponse model constructor.
     * @property {module:model/ActivityResponse}
     */
    ActivityResponse: ActivityResponse,
    /**
     * The ApplicationRequest model constructor.
     * @property {module:model/ApplicationRequest}
     */
    ApplicationRequest: ApplicationRequest,
    /**
     * The ApplicationResponse model constructor.
     * @property {module:model/ApplicationResponse}
     */
    ApplicationResponse: ApplicationResponse,
    /**
     * The BusinessBean model constructor.
     * @property {module:model/BusinessBean}
     */
    BusinessBean: BusinessBean,
    /**
     * The BusinessIndustryRequest model constructor.
     * @property {module:model/BusinessIndustryRequest}
     */
    BusinessIndustryRequest: BusinessIndustryRequest,
    /**
     * The BusinessIndustryResponse model constructor.
     * @property {module:model/BusinessIndustryResponse}
     */
    BusinessIndustryResponse: BusinessIndustryResponse,
    /**
     * The BusinessRequest model constructor.
     * @property {module:model/BusinessRequest}
     */
    BusinessRequest: BusinessRequest,
    /**
     * The BusinessResponse model constructor.
     * @property {module:model/BusinessResponse}
     */
    BusinessResponse: BusinessResponse,
    /**
     * The ComponentRequest model constructor.
     * @property {module:model/ComponentRequest}
     */
    ComponentRequest: ComponentRequest,
    /**
     * The ComponentResponse model constructor.
     * @property {module:model/ComponentResponse}
     */
    ComponentResponse: ComponentResponse,
    /**
     * The ConfigurationRequest model constructor.
     * @property {module:model/ConfigurationRequest}
     */
    ConfigurationRequest: ConfigurationRequest,
    /**
     * The ConfigurationResponse model constructor.
     * @property {module:model/ConfigurationResponse}
     */
    ConfigurationResponse: ConfigurationResponse,
    /**
     * The ContactRequest model constructor.
     * @property {module:model/ContactRequest}
     */
    ContactRequest: ContactRequest,
    /**
     * The ContactResponse model constructor.
     * @property {module:model/ContactResponse}
     */
    ContactResponse: ContactResponse,
    /**
     * The FormItemRequest model constructor.
     * @property {module:model/FormItemRequest}
     */
    FormItemRequest: FormItemRequest,
    /**
     * The FormItemResponse model constructor.
     * @property {module:model/FormItemResponse}
     */
    FormItemResponse: FormItemResponse,
    /**
     * The FormRequest model constructor.
     * @property {module:model/FormRequest}
     */
    FormRequest: FormRequest,
    /**
     * The FormResponse model constructor.
     * @property {module:model/FormResponse}
     */
    FormResponse: FormResponse,
    /**
     * The GenericBean model constructor.
     * @property {module:model/GenericBean}
     */
    GenericBean: GenericBean,
    /**
     * The IActivityBean model constructor.
     * @property {module:model/IActivityBean}
     */
    IActivityBean: IActivityBean,
    /**
     * The IApplicationBean model constructor.
     * @property {module:model/IApplicationBean}
     */
    IApplicationBean: IApplicationBean,
    /**
     * The IBusinessIndustryResponse model constructor.
     * @property {module:model/IBusinessIndustryResponse}
     */
    IBusinessIndustryResponse: IBusinessIndustryResponse,
    /**
     * The IComponentBean model constructor.
     * @property {module:model/IComponentBean}
     */
    IComponentBean: IComponentBean,
    /**
     * The IContactBean model constructor.
     * @property {module:model/IContactBean}
     */
    IContactBean: IContactBean,
    /**
     * The IFormBean model constructor.
     * @property {module:model/IFormBean}
     */
    IFormBean: IFormBean,
    /**
     * The IFormItemBean model constructor.
     * @property {module:model/IFormItemBean}
     */
    IFormItemBean: IFormItemBean,
    /**
     * The IMatrixBean model constructor.
     * @property {module:model/IMatrixBean}
     */
    IMatrixBean: IMatrixBean,
    /**
     * The IMatrixItemBean model constructor.
     * @property {module:model/IMatrixItemBean}
     */
    IMatrixItemBean: IMatrixItemBean,
    /**
     * The IProductBean model constructor.
     * @property {module:model/IProductBean}
     */
    IProductBean: IProductBean,
    /**
     * The IProfileBean model constructor.
     * @property {module:model/IProfileBean}
     */
    IProfileBean: IProfileBean,
    /**
     * The IProfileItemBean model constructor.
     * @property {module:model/IProfileItemBean}
     */
    IProfileItemBean: IProfileItemBean,
    /**
     * The IProfileRequestBean model constructor.
     * @property {module:model/IProfileRequestBean}
     */
    IProfileRequestBean: IProfileRequestBean,
    /**
     * The IProfileResponse model constructor.
     * @property {module:model/IProfileResponse}
     */
    IProfileResponse: IProfileResponse,
    /**
     * The LoginRequest model constructor.
     * @property {module:model/LoginRequest}
     */
    LoginRequest: LoginRequest,
    /**
     * The LoginResponse model constructor.
     * @property {module:model/LoginResponse}
     */
    LoginResponse: LoginResponse,
    /**
     * The MatrixItemBean model constructor.
     * @property {module:model/MatrixItemBean}
     */
    MatrixItemBean: MatrixItemBean,
    /**
     * The MatrixItemRequest model constructor.
     * @property {module:model/MatrixItemRequest}
     */
    MatrixItemRequest: MatrixItemRequest,
    /**
     * The MatrixItemResponse model constructor.
     * @property {module:model/MatrixItemResponse}
     */
    MatrixItemResponse: MatrixItemResponse,
    /**
     * The MatrixRequest model constructor.
     * @property {module:model/MatrixRequest}
     */
    MatrixRequest: MatrixRequest,
    /**
     * The MatrixResponse model constructor.
     * @property {module:model/MatrixResponse}
     */
    MatrixResponse: MatrixResponse,
    /**
     * The PdfBean model constructor.
     * @property {module:model/PdfBean}
     */
    PdfBean: PdfBean,
    /**
     * The PdfRequest model constructor.
     * @property {module:model/PdfRequest}
     */
    PdfRequest: PdfRequest,
    /**
     * The PdfResponse model constructor.
     * @property {module:model/PdfResponse}
     */
    PdfResponse: PdfResponse,
    /**
     * The ProductRequest model constructor.
     * @property {module:model/ProductRequest}
     */
    ProductRequest: ProductRequest,
    /**
     * The ProductResponse model constructor.
     * @property {module:model/ProductResponse}
     */
    ProductResponse: ProductResponse,
    /**
     * The ProfileItemBean model constructor.
     * @property {module:model/ProfileItemBean}
     */
    ProfileItemBean: ProfileItemBean,
    /**
     * The ProfileItemRequest model constructor.
     * @property {module:model/ProfileItemRequest}
     */
    ProfileItemRequest: ProfileItemRequest,
    /**
     * The ProfileItemResponse model constructor.
     * @property {module:model/ProfileItemResponse}
     */
    ProfileItemResponse: ProfileItemResponse,
    /**
     * The ProfileRequest model constructor.
     * @property {module:model/ProfileRequest}
     */
    ProfileRequest: ProfileRequest,
    /**
     * The ProfileRequestRequest model constructor.
     * @property {module:model/ProfileRequestRequest}
     */
    ProfileRequestRequest: ProfileRequestRequest,
    /**
     * The ProfileRequestResponse model constructor.
     * @property {module:model/ProfileRequestResponse}
     */
    ProfileRequestResponse: ProfileRequestResponse,
    /**
     * The ProfileResponse model constructor.
     * @property {module:model/ProfileResponse}
     */
    ProfileResponse: ProfileResponse,
    /**
     * The RegisterRequest model constructor.
     * @property {module:model/RegisterRequest}
     */
    RegisterRequest: RegisterRequest,
    /**
     * The RegisterResponse model constructor.
     * @property {module:model/RegisterResponse}
     */
    RegisterResponse: RegisterResponse,
    /**
     * The UserBean model constructor.
     * @property {module:model/UserBean}
     */
    UserBean: UserBean,
    /**
     * The UserRequest model constructor.
     * @property {module:model/UserRequest}
     */
    UserRequest: UserRequest,
    /**
     * The UserResponse model constructor.
     * @property {module:model/UserResponse}
     */
    UserResponse: UserResponse,
    /**
     * The DefaultApi service constructor.
     * @property {module:api/DefaultApi}
     */
    DefaultApi: DefaultApi
  };

  return exports;
}));
